/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { translationSchema } from '@well/translation';
import { ShipmentStatusType } from './shipment-status-type.enum';

export const shipmentStatuses = new Map<string, {class: string, statusText: string}>([
  ['', { // default in case status text not found in map
    class: '',
    statusText: ''
  }],
  [ShipmentStatusType.requested.toString(), {
    class: 'before-pickup',
    statusText: translationSchema['delivery-app']['shipment'].status.requested
  }],
  [ShipmentStatusType.request_rejected.toString(), {
    class: 'failed',
    statusText: translationSchema['delivery-app']['shipment'].status.request_rejected
  }],
  [ShipmentStatusType.cancelled.toString(), {
    class: 'cancelled',
    statusText: translationSchema['delivery-app']['shipment'].status.cancelled
  }],
  [ShipmentStatusType.before_pickup.toString(), {
    class: 'before-pickup',
    statusText: translationSchema['delivery-app']['shipment'].status.before_pickup
  }],
  [ShipmentStatusType.in_progress.toString(), {
    class: 'in-progress',
    statusText: translationSchema['delivery-app']['shipment'].status.in_progress
  }],
  [ShipmentStatusType.partially_in_progress.toString(), {
    class: 'in-progress',
    statusText: translationSchema['delivery-app']['shipment'].status.partially_in_progress
  }],
  [ShipmentStatusType.unavailable_cargo.toString(), {
    class: 'unavailable-cargo',
    statusText: translationSchema['delivery-app']['shipment'].status.unavailable_cargo
  }],
  [ShipmentStatusType.returned_to_origin.toString(), {
    class: 'return-to-origin',
    statusText: translationSchema['delivery-app']['shipment'].status.returned_to_origin
  }],
  [ShipmentStatusType.partially_returned_to_origin.toString(), {
    class: 'return-to-origin',
    statusText: translationSchema['delivery-app']['shipment'].status.partially_returned_to_origin
  }],
  [ShipmentStatusType.partially_in_transit.toString(), {
    class: 'in-transit',
    statusText: translationSchema['delivery-app']['shipment'].status.partially_in_transit
  }],
  [ShipmentStatusType.in_transit.toString(), {
    class: 'in-transit',
    statusText: translationSchema['delivery-app']['shipment'].status.in_transit
  }],
  [ShipmentStatusType.partially_transit_end.toString(), {
    class: 'in-transit',
    statusText: translationSchema['delivery-app']['shipment'].status.partially_transit_end
  }],
  [ShipmentStatusType.transit_end.toString(), {
    class: 'in-transit',
    statusText: translationSchema['delivery-app']['shipment'].status.transit_end
  }],
  [ShipmentStatusType.return_to_origin.toString(), {
    class: 'return-to-origin',
    statusText: translationSchema['delivery-app']['shipment'].status.return_to_origin
  }],
  [ShipmentStatusType.partially_return_to_origin.toString(), {
    class: 'return-to-origin',
    statusText: translationSchema['delivery-app']['shipment'].status.partially_return_to_origin
  }],
  [ShipmentStatusType.lost.toString(), {
    class: 'lost',
    statusText: translationSchema['delivery-app']['shipment'].status.lost
  }],
  [ShipmentStatusType.partially_completed.toString(), {
    class: 'completed',
    statusText: translationSchema['delivery-app']['shipment'].status.partially_completed
  }],
  [ShipmentStatusType.mixed.toString(), {
    class: 'mixed',
    statusText: translationSchema['delivery-app']['shipment'].status.mixed
  }],
  [ShipmentStatusType.mixed_with_failure.toString(), {
    class: 'mixed-with-failure',
    statusText: translationSchema['delivery-app']['shipment'].status.mixed_with_failure
  }],
  [ShipmentStatusType.completed.toString(), {
    class: 'completed',
    statusText: translationSchema['delivery-app']['shipment'].status.completed
  }],
  [ShipmentStatusType.completed_with_failure.toString(), {
    class: 'completed-with-failure',
    statusText: translationSchema['delivery-app']['shipment'].status.completed_with_failure
  }],
  [ShipmentStatusType.undelivered.toString(), {
    class: 'failed',
    statusText: translationSchema['delivery-app']['shipment'].status.undelivered
  }],
  [ShipmentStatusType.documents_received.toString(), {
    class: 'completed',
    statusText: translationSchema['delivery-app']['shipment'].status.documents_received
  }]
]);
